const TOKEN_KEY = 'cortlex-token';
const ADMIN_TOKEN_KEY = 'cortlex-admin-token';

export async function setItem(name, value) {
  try {
    window.localStorage.setItem(name, value);
  } catch (error) {
    console.error(`Error setting item ${name} from window.localStorage`);
    console.error(error);
  }
}

export async function getItem(name) {
  try {
    return window.localStorage.getItem(name);
  } catch (error) {
    console.error(`Error getting item ${name} from window.localStorage`);
    console.error(error);
  }
}

export function getToken() {
  return window.localStorage.getItem(TOKEN_KEY);
}

export function getSessionToken() {
  return window.sessionStorage.getItem(TOKEN_KEY);
}

export async function setToken(token: string) {
  return new Promise((resolve, reject) => {
    try {
      const response = window.localStorage.setItem(TOKEN_KEY, token);
      resolve(response);
    } catch (error) {
      console.error('Error setting token in window.localStorage');
      console.error(error);
      reject(error);
    }
  });
}

export async function setTokenInSession(token: string) {
  return new Promise((resolve, reject) => {
    try {
      const response = window.sessionStorage.setItem(TOKEN_KEY, token);
      resolve(response);
    } catch (error) {
      console.error('Error setting token in window.localStorage');
      console.error(error);
      reject(error);
    }
  });
}

export async function removeToken() {
  try {
    window.localStorage.removeItem(TOKEN_KEY);
    window.sessionStorage.removeItem(TOKEN_KEY);
  } catch (error) {
    console.error('Error removing token from window.localStorage');
    console.error(error);
    return error;
  }
}

export async function setAdminToken(token: string) {
  return new Promise((resolve, reject) => {
    try {
      const response = window.localStorage.setItem(ADMIN_TOKEN_KEY, token);
      resolve(response);
    } catch (error) {
      console.error('Error setting admin token in window.localStorage');
      console.error(error);
      reject(error);
    }
  });
}

export async function removeAdminToken() {
  try {
    return window.localStorage.removeItem(ADMIN_TOKEN_KEY);
  } catch (error) {
    console.error('Error removing admin token from window.localStorage');
    console.error(error);
    return error;
  }
}

export function getAdminToken() {
  return window.localStorage.getItem(ADMIN_TOKEN_KEY);
}

const storage = {
  getToken,
  setToken,
  removeToken,
  getItem,
  setItem,
  setAdminToken,
  getAdminToken,
  removeAdminToken,
  setTokenInSession,
  getSessionToken,
};

export default storage;
